import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) {
    this.title.setTitle("International Money Transfer - About Us | SingX");
    this.canonicalService.updateCanonicalUrl('/aboutus');
    this.meta.updateTag({ name: 'description', content: 'SingX brings you the smartest way to Transfer Money Internationally. SingX Singapore offers Faster and convenient cross border payment solutions for individuals and businesses.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Fast Money Transfer Overseas, International Business Payment, Money Transfer to India, Money Send to India, International Money Transfer, Money Transfer India, Transfer Money to India.' })
  }

  ngOnInit(): void {
  }

}
